import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

function Category() {
  return (
    <>
      {/* <!-- Category Start --> */}
      <section className="category-section">
        <div className="container-xxl">
          <div className="container">
            <div className="category-header wow fadeInUp" data-wow-delay="0.1s">
              <div>
                <span className="category-eyebrow">Property types</span>
                <h2 className="category-title">Find your next space</h2>
                <p className="category-subtitle">
                  We prioritize your goals, pairing trusted inventory with
                  clear guidance so every step feels confident and simple.
                </p>
              </div>
              <Link className="category-header-link" to="/properties">
                Browse all listings
              </Link>
            </div>

            <div className="row g-4">
              <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                <article className="category-card">
                  <div className="category-card-top">
                    <span className="category-icon">
                      <Icon
                        icon="material-symbols-light:apartment"
                        width="1.6rem"
                        height="1.6rem"
                      />
                    </span>
                    <span className="category-count">30+</span>
                  </div>
                  <h3>Block of Flats</h3>
                  <p>Compact multi-family homes in high-demand zones.</p>
                  <Link className="category-link" to="/properties">
                    View listings
                  </Link>
                </article>
              </div>

              <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
                <article className="category-card">
                  <div className="category-card-top">
                    <span className="category-icon">
                      <Icon
                        icon="material-symbols:villa"
                        width="1.6rem"
                        height="1.6rem"
                      />
                    </span>
                    <span className="category-count">20+</span>
                  </div>
                  <h3>Terrace</h3>
                  <p>Modern terraces with premium finishes and space.</p>
                  <Link className="category-link" to="/properties">
                    View listings
                  </Link>
                </article>
              </div>

              <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
                <article className="category-card">
                  <div className="category-card-top">
                    <span className="category-icon">
                      <Icon
                        icon="icon-park-outline:homestay"
                        width="1.6rem"
                        height="1.6rem"
                      />
                    </span>
                    <span className="category-count">20+</span>
                  </div>
                  <h3>Bungalows</h3>
                  <p>Single-level comfort with generous outdoor space.</p>
                  <Link className="category-link" to="/properties">
                    View listings
                  </Link>
                </article>
              </div>

              <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
                <article className="category-card">
                  <div className="category-card-top">
                    <span className="category-icon">
                      <Icon
                        icon="bxs:landscape"
                        width="1.6rem"
                        height="1.6rem"
                      />
                    </span>
                    <span className="category-count">100+</span>
                  </div>
                  <h3>Lands</h3>
                  <p>Secure plots for residential and commercial builds.</p>
                  <Link className="category-link" to="/properties">
                    View listings
                  </Link>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Category End --> */}
    </>
  );
}

export default Category;
